import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { get_for_customer } from "../../../utils";

class ProductItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      stock: "InStock",
      quantity: 1,
      image: "",
    };
  }

  onClickHandle(img) {
    this.setState({ image: img });
  }
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  minusQty = () => {
    if (this.state.quantity > 1) {
      this.setState({ stock: "InStock" });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (100 >= this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({ stock: "Out of Stock !" });
    }
  };
  changeQty = (e) => {
    this.setState({ quantity: parseInt(e.target.value) });
  };

  render() {
    const {
      product,
      symbol,
      onAddToCartClicked,
      onAddToWishlistClicked,
      user,
    } = this.props;
    return (
      <div className="product-box">
        <div className="img-wrapper">
          <div className="front">
            <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}>
              <img
                src={
                  product.product_images[0] && product.product_images[0].image
                }
                className="img-fluid"
                alt=""
              />
            </Link>
          </div>
          <div className="cart-info cart-wrap">
            {get_for_customer(
              user,
              <>
                <button
                  title="Add to cart"
                  onClick={() => onAddToCartClicked({ product, quantity: 1 })}
                >
                  <i className="fa fa-shopping-cart" aria-hidden="true" />
                </button>
                <a
                  href="javascript:void(0)"
                  title="Add to Wishlist"
                  onClick={() =>
                    onAddToWishlistClicked({ product, quantity: 1 })
                  }
                >
                  <i className="fa fa-heart" aria-hidden="true" />
                </a>
              </>
            )}
            <a
              href="javascript:void(0)"
              data-toggle="modal"
              data-target="#quick-view"
              title="Quick View"
              onClick={this.onOpenModal}
            >
              <i className="fa fa-search" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="product-detail">
          <div>
            <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}>
              <h6>{product.product_name}</h6>
            </Link>
            <h4>
              {symbol}
              {product.product_price}
            </h4>
          </div>
        </div>
        <Modal open={this.state.open} onClose={this.onCloseModal} center>
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content quick-view-modal">
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6  col-xs-12">
                    <div className="quick-view-img">
                      <img
                        src={
                          product.product_images[0] &&
                          product.product_images[0].image
                        }
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 rtl-text">
                    <div className="product-right">
                      <h2> {product.product_name} </h2>
                      <h4>
                        {symbol}
                        {product.product_price}
                      </h4>
                      <div className="border-product">
                        <h6 className="product-title">product details</h6>
                        <p>{product.product_description}</p>
                      </div>
                      {get_for_customer(
                        user,
                        <div className="product-description border-product">
                          <h6 className="product-title">quantity</h6>
                          <div className="qty-box">
                            <div className="input-group">
                              <span className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn quantity-left-minus"
                                  onClick={this.minusQty}
                                  data-type="minus"
                                  data-field=""
                                >
                                  <i className="fa fa-angle-left" />
                                </button>
                              </span>
                              <input
                                type="text"
                                name="quantity"
                                value={this.state.quantity}
                                onChange={this.changeQty}
                                className="form-control input-number"
                              />
                              <span className="input-group-prepend">
                                <button
                                  type="button"
                                  className="btn quantity-right-plus"
                                  onClick={this.plusQty}
                                  data-type="plus"
                                  data-field=""
                                >
                                  <i className="fa fa-angle-right" />
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="product-buttons">
                        {get_for_customer(
                          user,
                          <button
                            className="btn btn-solid"
                            onClick={() =>
                              onAddToCartClicked({
                                product,
                                quantity: 1,
                              })
                            }
                          >
                            add to cart
                          </button>
                        )}
                        <Link
                          to={`${process.env.PUBLIC_URL}/product/${product._id}`}
                          onClick={() => this.onCloseModal()}
                          className="btn btn-solid"
                        >
                          view detail
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ProductItem;
